import { useEffect, useState } from "react";
import { BRAND, NAV_LINKS } from "../../mock";

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className="fixed top-0 left-0 right-0 z-50"
      style={{
        padding: "20px 28px",
        transition: "background 0.3s ease, backdrop-filter 0.3s ease",
        background: scrolled ? "rgba(196,185,168,0.72)" : "transparent",
        backdropFilter: scrolled ? "blur(14px)" : "none",
        WebkitBackdropFilter: scrolled ? "blur(14px)" : "none",
      }}
    >
      <div className="flex items-center justify-between max-w-[1440px] mx-auto">
        {/* Brand */}
        <a href="#top" className="flex items-baseline gap-2">
          <span
            style={{
              fontFamily: '"DM Sans", sans-serif',
              fontSize: 13,
              fontWeight: 600,
              letterSpacing: "0.04em",
              color: "var(--ink)",
              textTransform: "uppercase",
            }}
          >
            {BRAND.channel}
          </span>
        </a>

        {/* Desktop nav pill */}
        <nav className="hidden md:block">
          <ul
            style={{
              display: "flex",
              alignItems: "center",
              gap: 4,
              padding: "6px 8px",
              background: "rgba(17,17,16,0.85)",
              border: "1px solid rgba(255,255,255,0.06)",
              borderRadius: 100,
              backdropFilter: "blur(14px)",
            }}
          >
            {NAV_LINKS.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  style={{
                    color: "rgba(250,250,248,0.78)",
                    fontSize: 12,
                    fontWeight: 500,
                    padding: "8px 16px",
                    borderRadius: 100,
                    transition: "all 0.2s",
                    display: "inline-block",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = "rgba(255,255,255,0.08)";
                    e.currentTarget.style.color = "var(--white)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = "transparent";
                    e.currentTarget.style.color = "rgba(250,250,248,0.78)";
                  }}
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        {/* Right CTA */}
        <a href="#contacto" className="btn-primary hidden md:inline-flex">
          Agenda una llamada →
        </a>

        {/* Mobile burger */}
        <button
          aria-label="Menu"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden"
          style={{
            width: 40,
            height: 40,
            borderRadius: 100,
            border: "1px solid var(--line-strong)",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <span
            style={{
              display: "block",
              width: 16,
              height: 1.5,
              background: "var(--ink)",
              boxShadow: open
                ? "none"
                : "0 -5px 0 var(--ink), 0 5px 0 var(--ink)",
              transform: open ? "rotate(45deg)" : "none",
              transition: "all 0.2s",
            }}
          />
        </button>
      </div>

      {/* Mobile dropdown */}
      {open && (
        <div
          className="md:hidden"
          style={{
            marginTop: 16,
            padding: "16px 20px",
            background: "rgba(17,17,16,0.92)",
            borderRadius: 16,
            backdropFilter: "blur(14px)",
          }}
        >
          <ul style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            {NAV_LINKS.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  onClick={() => setOpen(false)}
                  style={{
                    color: "var(--white)",
                    fontSize: 14,
                    fontWeight: 500,
                    padding: "8px 0",
                    display: "block",
                  }}
                >
                  {link.label}
                </a>
              </li>
            ))}
            <li style={{ marginTop: 10 }}>
              <a
                href="#contacto"
                onClick={() => setOpen(false)}
                className="btn-primary"
                style={{ background: "var(--white)", color: "var(--ink)" }}
              >
                Agenda una llamada →
              </a>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}
